
import Vue from "vue";

export default Vue.extend({
    name: "HelpDocuments",
    props: {
        authenticated: Boolean,
    },
    methods: {
        openURL(url: string) {
            window.open(url, "_blank");
        },
    }
});
